import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import { Modal, Button, Form, FormControl, OverlayTrigger, Popover } from 'react-bootstrap';
import { Line } from 'react-chartjs-2';
// style
import s from './Dashboard.css'
import rs from '../../storeCommon.css';
// helper
import messages from '../../../locale/messages';
// Component
import CurrencyConverter from '../../CurrencyConverter';
import Link from '../../Link';
//Images
import OrderImageOne from '../../../../public/StoreIcon/groceryorderOne.svg';
import OrderImageTwo from '../../../../public/StoreIcon/groceryorderTwo.svg';
import OrderImageThree from '../../../../public/StoreIcon/groceryorderThree.svg';
import OrderImageFour from '../../../../public/StoreIcon/groceryorderFour.svg';

import OrderEarning from '../../../../public/StoreIcon/earnings.svg';
import { FaDownload, FaInfoCircle } from 'react-icons/fa';

const BOOKING_STATUSES = [
  { value: 'all', label: 'All Statuses' },
  { value: 'completed', label: 'Completed' },
  { value: 'expired', label: 'Expired' },
  { value: 'declined', label: 'Declined' },
  { value: 'cancelledByUser', label: 'Cancelled by User' },
  { value: 'deliveryNotFound', label: 'Delivery Not Found' },
];

class Dashboard extends Component {
  static defaultProps = {
    orders: {
      total: 0,
      today: 0,
      week: 0,
      month: 0
    },
    earnings: {
      total: 0,
      today: 0,
      week: 0,
      month: 0,
      currency: 'USD'
    },
    historyLoading: true,
    history: {
      ordersHistory: {
        count: 0,
        start: null,
        end: null,
        ordersLabels: [],
        ordersData: []
      }
    }
  };

  constructor(props) {
    super(props);
    this.state = {
      requestDays: 30,
      showDownloadModal: false,
      dlStartDate: '',
      dlEndDate: '',
      dlDeliveryType: '',
      dlBookingStatus: 'all',
      isDownloading: false,
    };

    this.handleOrderHistory = this.handleOrderHistory.bind(this);
    this.renderAmount = this.renderAmount.bind(this);
    this.renderOrdersCard = this.renderOrdersCard.bind(this);
    this.renderEarningsCard = this.renderEarningsCard.bind(this);
    this.openDownloadModal = this.openDownloadModal.bind(this);
    this.closeDownloadModal = this.closeDownloadModal.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
  }

  handleOrderHistory(requestDays) {
    const { historyRefetch } = this.props;
    this.setState({ requestDays });
    historyRefetch({ requestDays });
  }

  openDownloadModal() {
    this.setState({ showDownloadModal: true });
  }

  closeDownloadModal() {
    this.setState({ showDownloadModal: false });
  }

  handleDownload() {
    const { dlStartDate, dlEndDate, dlDeliveryType, dlBookingStatus } = this.state;
    const params = new URLSearchParams();
    if (dlStartDate) params.set('startDate', dlStartDate);
    if (dlEndDate) params.set('endDate', dlEndDate);
    if (dlDeliveryType !== '') params.set('isDoorStepDelivery', dlDeliveryType);
    if (dlBookingStatus && dlBookingStatus !== 'all') params.set('bookingStatus', dlBookingStatus);

    this.setState({ isDownloading: true });
    window.location.href = `/export-shop-data?${params.toString()}`;

    // Reset loading state after 5s — browser starts download in the background
    setTimeout(() => {
      this.setState({ isDownloading: false });
      this.closeDownloadModal();
    }, 1000);

  }

  renderAmount(amount, from) {
    const { toCurrency } = this.props;
    if (amount >= 0 && from && toCurrency) {
      return <CurrencyConverter from={from} amount={amount} to={toCurrency} />;
    }

    return <div />;
  }

  renderOrdersCard(label, orders, OrderImage, className) {
    return (
      <Col xl={3} md={12} lg={6} sm={12} xs={12} className={s.marginBottom}>
        <Link className={s.mainContainerLink} to={'/store/order-management/upcoming'}>
          <div className={cx(s.mainContainer, className)}>
            <span className={s.orderImg}><img src={OrderImage} alt='order icon' /></span>
            <p className={cx(s.numberText, rs.noMargin)}>{orders}</p>
            <span className={s.subtext}>{label}</span>
          </div>
        </Link>
      </Col>
    );
  }

  renderEarningsCard(label, amount, currency, imageClass) {
    return (
      <Col xl={3} md={12} lg={6} sm={12} xs={12} className={cx(rs.space5, rs.spaceTop4)}>
        <Link className={s.mainContainerLink} to={'/store/transaction/completed'}>
          <div className={cx(s.earnSection, 'earnSectionRTL')}>
            <span className={cx(s.earnImg, imageClass, 'earnImgRTL')}><img src={OrderEarning} alt='order earning icon' /></span>
            <p className={cx(s.numberText, rs.spaceTop2)}>{this.renderAmount(amount, currency)}</p>
            <span className={s.subtext}>{label}</span>
          </div>
        </Link>
      </Col>
    );
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { orders, earnings, historyLoading, history, history: { ordersHistory } } = this.props;
    const { requestDays, showDownloadModal, dlStartDate, dlEndDate, dlDeliveryType, dlBookingStatus, isDownloading } = this.state;

    const options = {
      responsive: true,
      labels: !historyLoading && history && ordersHistory && ordersHistory.ordersLabels || [],
      datasets: [
        {
          label: formatMessage(messages.ordersLabel),
          data: !historyLoading && history && ordersHistory && ordersHistory.ordersData || [],
          backgroundColor: "#E62529",
          borderColor: "#E62529",
          fill: false
        }
      ],
      maintainAspectRatio: false,
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: formatMessage(messages.ordersLabel)
          }
        }],
        xAxes: [{
          scaleLabel: {
            display: true,
            labelString: formatMessage(messages.tripDate)
          }
        }]

      },
      legend: {
        onClick: (e) => e.stopPropagation()
      }
    };

    return (
      <div className={'mainContainer'}>
        <Container fluid>
          {/* Download CSV Button */}
          <div className="d-flex justify-content-end align-items-center mb-3">
            <OverlayTrigger
              trigger={['hover', 'focus']}
              placement="left"
              overlay={
                <Popover id="popover-download-csv">
                  <Popover.Title as="h6">Download Order Data (CSV)</Popover.Title>
                  <Popover.Content>
                    Download your store&apos;s order history as a CSV file.
                    You can filter by <strong>date range</strong>, <strong>delivery type</strong>,
                    and <strong>order status</strong> before downloading.
                  </Popover.Content>
                </Popover>
              }
            >
              <span className="mr-2 text-muted" style={{ cursor: 'pointer' }}>
                <FaInfoCircle size={16} />
              </span>
            </OverlayTrigger>
            <Button
              variant="outline-danger"
              className={s.downloadBtn}
              onClick={this.openDownloadModal}
            >
              <FaDownload className="mr-1" />
              Download Order Data (CSV)
            </Button>
          </div>

          <Row>
            {/* Orders */}
            {this.renderOrdersCard(formatMessage(messages.totalOrder), orders?.total, OrderImageOne, s.imageOne)}
            {this.renderOrdersCard(formatMessage(messages.todayOrder), orders?.today, OrderImageTwo, s.imageTwo)}
            {this.renderOrdersCard(formatMessage(messages.thisWeekOrder), orders?.week, OrderImageThree, s.imageThree)}
            {this.renderOrdersCard(formatMessage(messages.thisMonthOrder), orders?.month, OrderImageFour, s.imageFour)}
            {/* Earnings */}
            {this.renderEarningsCard(formatMessage(messages.totalEranings), earnings?.total, earnings?.currency, s.earnImgOne)}
            {this.renderEarningsCard(formatMessage(messages.todayEarnings), earnings?.today, earnings?.currency, s.earnImgTwo)}
            {this.renderEarningsCard(formatMessage(messages.thisWeekEarnings), earnings?.week, earnings?.currency, s.earnImgThree)}
            {this.renderEarningsCard(formatMessage(messages.thisMonthEarnings), earnings?.month, earnings?.currency, s.earnImgFour)}
            {
              !historyLoading && history && ordersHistory && <Col lg={12} md={12} sm={12} xs={12} className={cx(rs.spaceTop1)}>
                <Row>
                  <Col lg={6} md={12} sm={12} xs={12} className={cx(rs.spaceTop2, rs.space4)}>
                    <h4 className={cx(s.orderHistoryText, 'textAlignRightRTL')}><FormattedMessage {...messages.orderHistory} /></h4>
                  </Col>
                  <Col lg={6} md={12} sm={12} xs={12} className={cx(rs.spaceTop2, rs.space4, 'text-right', s.mobileTextLeft, 'textAlignLeftRTL', 'rightAlignRTL')}>
                    <select
                      className={cx(rs.activeSelect, rs.storeSelectInput, rs.orderSlectWidth, s.selectWidth)}
                      value={requestDays} disabled={historyLoading}
                      onChange={(e) => this.handleOrderHistory(e.target && e.target.value)}
                    >
                      <option value={7}>{formatMessage(messages.last7Days)}</option>
                      <option value={15}>{formatMessage(messages.last15Days)}</option>
                      <option value={30}>{formatMessage(messages.last30Days)}</option>
                    </select>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12} md={12} sm={12} xs={12} className={'chart-container'}>
                    <Line
                      data={options}
                      width={100}
                      height={50}
                      options={options}
                    />
                  </Col>
                </Row>
              </Col>
            }
          </Row>
        </Container>

        {/* Download CSV Modal */}
        <Modal show={showDownloadModal} onHide={this.closeDownloadModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>
              <FaDownload className="mr-2 text-danger" />
              Download Order Data
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              {/* Date Range */}
              <Form.Group>
                <Form.Label><strong>Date range</strong></Form.Label>
                <div className={s.modalDateRow}>
                  <FormControl
                    type="date"
                    value={dlStartDate}
                    onChange={(e) => this.setState({ dlStartDate: e.target.value })}
                    max={dlEndDate || undefined}
                  />
                  <span className="text-muted">to</span>
                  <FormControl
                    type="date"
                    value={dlEndDate}
                    onChange={(e) => this.setState({ dlEndDate: e.target.value })}
                    min={dlStartDate || undefined}
                  />
                </div>
                <Form.Text className="text-muted">
                  Leave empty to download all dates.
                </Form.Text>
              </Form.Group>

              {/* Delivery Type */}
              <Form.Group>
                <Form.Label><strong>Delivery Type</strong></Form.Label>
                <FormControl
                  as="select"
                  value={dlDeliveryType}
                  onChange={(e) => this.setState({ dlDeliveryType: e.target.value })}
                >
                  <option value="">All (Delivery & Self Pickup)</option>
                  <option value="true">Delivery (ASAP Driver)</option>
                  <option value="false">Self Pickup</option>
                </FormControl>
              </Form.Group>

              {/* Booking Status */}
              <Form.Group>
                <Form.Label><strong>Order Status</strong></Form.Label>
                <FormControl
                  as="select"
                  value={dlBookingStatus}
                  onChange={(e) => this.setState({ dlBookingStatus: e.target.value })}
                >
                  {BOOKING_STATUSES.map(({ value, label }) => (
                    <option key={value} value={value}>{label}</option>
                  ))}
                </FormControl>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeDownloadModal} disabled={isDownloading}>
              Batal
            </Button>
            <Button variant="danger" onClick={this.handleDownload} disabled={isDownloading}>
              {isDownloading ? (
                <>
                  <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" />
                  Preparing download...
                </>
              ) : (
                <>
                  <FaDownload className="mr-1" />
                  Download CSV
                </>
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      </div >
    );
  }
};

const mapStateToProps = (state) => ({
  userId: state.user.id,
  toCurrency: state.siteSettings && state.siteSettings.data && state.siteSettings.data.currency
});

const mapDispatchToProps = {
};

export default injectIntl(withStyles(s, rs)(connect(mapStateToProps, mapDispatchToProps)(Dashboard)));
